import React from "react";
import {
	BooleanInput,
	Datagrid,
	EditButton,
	Filter,
	List,
	TextField,
	TextInput,
	ShowButton,
} from "react-admin";

import { CustomDeleteButtonWithCustomConfirm } from "../../customComponents/CustomButtons";
import { userPreferences } from "../../utils/fakeUserPrefrences";
import { constants } from "../../utils/constants";
import { CustomBooleanInput } from "../../customComponents/CustomBooleanInput";

const SurveyFilter = (props) => (
	<Filter {...props}>
		<TextInput source="search" alwaysOn />
		<BooleanInput source="isActive" defaultValue={true} />
	</Filter>
);

export const SurveyList = (props) => {
	return (
		<List
			{...props}
			perPage={constants.perPage}
			bulkActionButtons={false}
			filters={<SurveyFilter />}
			exporter={false}
		>
			<Datagrid>
				<TextField
					source={`title.${userPreferences.defaultTranslationLanguage}`}
					sortable={false}
				/>
				<TextField
					source={`name.${userPreferences.defaultTranslationLanguage}`}
					sortable={false}
				/>
				<CustomBooleanInput source="isActive" sortable={false} />
				<ShowButton />
				<EditButton />
				<CustomDeleteButtonWithCustomConfirm mutationMode="pessimistic" />
			</Datagrid>
		</List>
	);
};

export default SurveyList;
